import { filterDefinitions } from "../definitions";
import { createChartFilterDefinitions } from "./createChartFilterDefinitions";
export const filterKeyMap = {
    applicationId: "aId",
    countryCode: "cC",
    region: "r",
    placement: "p",
    productId: "pId",
    variantId: "vId",
    paywallId: "pWId",
    experimentId: "eId",
    campaignId: "cId",
    audienceId: "aDId",
    environment: "e",
    store: "s",
    appVersion: "aV",
    sdkVersion: "sV",
    productDuration: "pD",
    eventType: "eT",
    revenueType: "rT",
    subStartType: "sST",
    autoRenewStatus: "aRS",
    revenueSource: "rS",
    chart: "cT"
};
export function transformFilters(filters) {
    return filters.reduce((acc, { key, value })=>{
        const mappedKey = filterKeyMap[key];
        if (!mappedKey) {
            console.error(`Invalid filter key: ${key}`);
            return acc;
        }
        const chartFilterDefinitions = createChartFilterDefinitions({
            defaults: {
                applicationId: []
            }
        });
        if (chartFilterDefinitions[mappedKey]) {
            let transformedValue = value;
            transformedValue = Array.isArray(transformedValue) && transformedValue.length === 0 ? null : transformedValue === "" ? null : transformedValue;
            return {
                ...acc,
                [mappedKey]: transformedValue
            };
        } else {
            console.error(`Invalid filter key: ${key}`);
            return {
                ...acc,
                [mappedKey]: value
            };
        }
    }, {});
}
export function reverseTransformFilters(chartFilters) {
    const reverseFilterKeyMap = Object.fromEntries(Object.entries(filterKeyMap).map(([key, value])=>[
            value,
            key
        ]));
    // Create a map of all filter definitions
    const allFilters = filterDefinitions.reduce((acc, def)=>{
        acc[def.key] = {
            ...def,
            type: "filter",
            active: false,
            value: {
                valueType: "string",
                value: []
            }
        };
        return acc;
    }, {});
    // Update active filters (except ones that are not in the chartFilters)
    Object.entries(chartFilters).forEach(([key, value])=>{
        if (value !== null && key !== "b" && key !== "dD" && key !== "dI" && key !== "dP" && key !== "dF" && key !== "dT") {
            const originalKey = reverseFilterKeyMap[key];
            if (originalKey && allFilters[originalKey]) {
                const filter = allFilters[originalKey];
                if (filter) {
                    filter.active = true;
                    filter.value = {
                        valueType: Array.isArray(value) ? "array" : typeof value,
                        value: Array.isArray(value) ? value : [
                            value
                        ]
                    };
                }
            }
        }
    });
    // Convert the map back to an array
    return Object.values(allFilters);
}
